// Copyright (c) 2017 Deere & Company

import {
    updateActualAuditDate,
    updateRecordAuditFile,
    updateRecordAuditModalVisibility,
    updateRecordAuditResults
} from './audit-recording';
import {deleteFile as deleteRecordAuditFile} from './delete-file';
import {readAuditCreditMemoClaims} from '../../shared/action-creators/read-audit-credit-memo-claims';
import {readAuditCreditMemos} from '../../shared/action-creators/read-audit-credit-memos';
import {readAuditRecords} from './get-audit-records';
import {readDebit} from './get-debit';
import {submitFullDebit} from './submit-full-debit';
import {updateAuditRecords} from './post-audit-records';
import {updateConfirmationModalVisibility} from './confirmation-modal';
import {updateFullDebitComments} from './full-debit-comments';
import {updateFullDebitModalVisibility} from './full-debit-modal';

export default {
    deleteRecordAuditFile,
    readAuditCreditMemoClaims,
    readAuditCreditMemos,
    readAuditRecords,
    readDebit,
    submitFullDebit,
    updateActualAuditDate,
    updateAuditRecords,
    updateConfirmationModalVisibility,
    updateFullDebitComments,
    updateFullDebitModalVisibility,
    updateRecordAuditFile,
    updateRecordAuditModalVisibility,
    updateRecordAuditResults
};



// WEBPACK FOOTER //
// ./src/tcsm/record-audit/action-creators/index.js